/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Contract_Not_ApprovedInputs */



/**
* | output |
* | --- |
* | "Not approved — this organization will NOT become active on its start date until a super-admin approves it." |
*
* @param {Partner_Org_Contract_Not_ApprovedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_not_approved = /** @type {((inputs?: Partner_Org_Contract_Not_ApprovedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Not_ApprovedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht freigegeben — diese Organisation wird zum Startdatum NICHT aktiviert, solange kein Super-Admin sie freigibt.")
	return /** @type {LocalizedString} */ ("Not approved — this organization will NOT become active on its start date until a super-admin approves it.")
});